import { API_DIRECTORY_THEME } from "../utils/constants";

const PRICING_PROP = {
    "parentPlanId": "",
    "type": "Advanced",
    "plan": "basic",
    "name": "Basic",
    "description": "dsjkjsdflkjf",
    "price": 9.99,
    "freeDays": 0,
    "visibility": "public",
    "status": "active",
    "containers": [
        {
            "name": "All Endpoints",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.0025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All Endpoints",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.0025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All Endpoints",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.0025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All Endpoints",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.0025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All Endpoints",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.0025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        }
    ],
    "groupId": "f608ac5f-e386-4e49-b1bf-3749b1789f9e",
    "groupName": "ksdjfklsjf",
    "startDate": "2024-03-12T20:03:22.604Z",
    "id": "107ea9b4-a323-4877-ae81-4fd5f2c05200",
    dealerPriceChecked: false
}

const DEALER_PRICING_PLAN = {
    "parentPlanId": "",
    "type": "Advanced",
    "plan": "custom",
    "name": "Custom Dealer Plan",
    "description": "Some custom dealer plan for testing",
    "price": 99.99,
    "freeDays": 0,
    "visibility": "private",
    "status": "active",
    "containers": [
        {
            "name": "All Gets",
            "description": "All Endpoints in a single container",
            "quota": 1000,
            "overage": 0.025,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All POSTs",
            "description": "All Endpoints in a single container",
            "quota": 10000,
            "overage": 0.035,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        },
        {
            "name": "All Deletes",
            "description": "All Endpoints in a single container",
            "quota": 100000,
            "overage": 0.045,
            "isFree": false,
            "id": "e6dc8c62-bb89-4420-8167-1fd3306f5377",
            "endPoints": [
                {
                    "summary": "Get a list of AAIA years",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-years",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA regions",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-regions",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA manufacturers",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-manufacturers",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA models",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-models",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA body types",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-body-types",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA submodels",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-submodels",
                    "verb": "get"
                },
                {
                    "summary": "Get a list of AAIA vehicles",
                    "apiInstanceId": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                    "route": "/get-aaia-vehicles",
                    "verb": "get"
                }
            ]
        }
    ],
    "groupId": "f608ac5f-e386-4e49-b1bf-3749b1789f9e",
    "groupName": "ksdjfklsjf",
    "startDate": "2024-03-12T20:03:22.604Z",
    "id": "ea9b4-a323-4877-ae81-4fd5f2c05200",
    dealerPriceChecked: false
}

const TRANSACTIONAL_PRICING_PROP =
{
    "name": "some transaction plan",
    "type": "Tiered",
    "visibility": "public",
    "rates": [
        {
            "startUnit": 0,
            "rate": 340,
            "endUnit": 1
        },
        {
            "startUnit": 2,
            "rate": 430,
            "endUnit": 9000
        },
        {
            "startUnit": 9001,
            "rate": 0.45,
            "endUnit": 12000
        },
        {
            "startUnit": 12001,
            "rate": 0.4
        }
    ],
    "id": "d749a77d-7e38-4518-91d0-3bced6c822b9",
    "status": "active",
    "startDate": "2025-01-21T09:53:59.214Z"
}

const SUB_PRICING_PROP = {
    "name": "some sub",
    "type": "Subscription",
    "visibility": "public",
    "subscriptionPrice": 600,
    "frequencyDuration": 1,
    "frequencyDurationType": "MONTH",
    "freemiumUnit": 3467,
    "id": "c033b055-283f-4106-aeb6-e1b2d9d6d38a",
    "status": "active",
}

const FREE_PRICING_PROP = {
    "name": "some free plan",
    "type": "Free",
    "visibility": "private",
    "id": "bd62d339-7415-4651-bf52-3f516b369819",
    "status": "active",
    "startDate": "2025-01-21T14:26:26.515Z"
}

const apiDetailsOnClickHandlers = {
    apiTypeFilter: (type) => { alert(JSON.stringify(type)) },
    apiCategoryFilter: (category) => { alert(JSON.stringify(category)) },
    sendEmailToConsumer: (payload) => { alert(JSON.stringify(payload)) },
    sendEmailToProvider: (payload) => { alert(JSON.stringify(payload)) },
    addToCart: (apiDetails) => { alert(JSON.stringify(apiDetails)) },
    myCart: () => { },
    viewInMyAPIs: (apiDetails) => { alert(JSON.stringify(apiDetails)) },
    buildWithApi: ({ appId, buildWithType, apiId }) => { console.log(appId, buildWithType, apiId) },
    selectPricingPlan: (planId) => { alert(JSON.stringify(planId)) }
}

const PRICING_PLAN_STATE = {
    selectedAndInCart: {
        selectPricingPlan: apiDetailsOnClickHandlers.selectPricingPlan,
        belongsTo: API_DIRECTORY_THEME.DEALER_API_DIRECTORY,
        isSelected: true,
        isAPIinCart: true,
        isAPIContracted: false,
    },
    inCart: {
        selectPricingPlan: apiDetailsOnClickHandlers.selectPricingPlan,
        belongsTo: API_DIRECTORY_THEME.DEALER_API_DIRECTORY,
        isSelected: false,
        isAPIinCart: true,
        isAPIContracted: false,
    },
    notInCart: {
        selectPricingPlan: apiDetailsOnClickHandlers.selectPricingPlan,
        belongsTo: API_DIRECTORY_THEME.DEALER_API_DIRECTORY,
        isSelected: false,
        isAPIinCart: false,
        isAPIContracted: false,
    },
    contracted: {
        selectPricingPlan: apiDetailsOnClickHandlers.selectPricingPlan,
        belongsTo: API_DIRECTORY_THEME.DEALER_API_DIRECTORY,
        isSelected: false,
        isAPIinCart: false,
        isAPIContracted: true,
    }

}

const cartDetails = [
    {
        id: "300271a1-4dd7-4729-bd86-febb92bc6e21",
        organizationId: "107ea9b4-a323-4877-ae81-4fd5f2c05200",
        apiId: "ce0d58af-b503-47ef-b785-ea279767cec0",
        apiPricingPlanId: "107ea9b4-a323-4877-ae81-4fd5f2c05200",
        consentViewStatus: false,
        apiType: "async-api",
        createdBy: "an.test.user@cdkauto.com",
        created: "2025-01-29T11:41:26.000Z",
        userId: "an.test.user@cdkauto.com"
    },
    {
        id: "b809069d-c921-4200-8c71-24982ecf3ece",
        organizationId: "b0dd5690-1576-4731-8378-9b748fd76815",
        apiId: "d218dc00-23b8-434e-981d-aac304921e5a",
        apiPricingPlanId: null,
        vsFields: null,
        appWebhookUrl: null,
        consentViewStatus: false,
        apiType: "async-api",
        createdBy: "kartheek.katta@cdk.com",
        created: "2024-09-11T00:00:00.000Z"
    },
    {
        id: "de2d83fd-0975-4452-8247-34e6b3f3e300",
        organizationId: "b0dd5690-1576-4731-8378-9b748fd76815",
        apiId: "2c58d422-5dc4-4ad4-8d62-ffb6831d28f9",
        apiPricingPlanId: null,
        vsFields: null,
        appWebhookUrl: null,
        consentViewStatus: false,
        apiType: "api",
        createdBy: "kartheek.katta@cdk.com",
        created: "2024-09-11T00:00:00.000Z"
    },
    {
        id: "de2d83fd-0975-4452-8247-34e6b3f3e300",
        organizationId: "b0dd5690-1576-4731-8378-9b748fd76815",
        apiId: "bc87d29a-a7cb-485c-b4f4-cc8cbaadb8e7",
        apiPricingPlanId: null,
        vsFields: null,
        appWebhookUrl: null,
        consentViewStatus: false,
        apiType: "api",
        createdBy: "kartheek.katta@cdk.com",
        created: "2024-09-11T00:00:00.000Z"
    },
    {
        id: "de2d83fd-0975-4452-8247-34e6b3f3e300",
        organizationId: "b0dd5690-1576-4731-8378-9b748fd76815",
        apiId: "08d811f0-526a-45c4-808a-2b3608ed3119",
        apiPricingPlanId: null,
        vsFields: null,
        appWebhookUrl: null,
        consentViewStatus: false,
        apiType: "api",
        createdBy: "kartheek.katta@cdk.com",
        created: "2024-09-11T00:00:00.000Z"
    },
    {
        id: "8edae3dd-aa59-4f65-8019-48508401103c",
        organizationId: "b0dd5690-1576-4731-8378-9b748fd76815",
        resourceType: "bundle",
        resourceId: "ea918f31-318a-4dff-b7eb-b44cb8cc6952",
        resourcePricingPlanId: "009dcc8f-8ce3-4eb4-80e4-3e7399a7d28b",
        vsFields: null,
        appWebhookUrl: null,
        consentViewStatus: false,
        createdBy: "kartheek.katta@cdk.com",
        created: "2024-09-11T00:00:00.000Z"
    }
];

const API_PLANS = [PRICING_PROP, TRANSACTIONAL_PRICING_PROP, SUB_PRICING_PROP, FREE_PRICING_PROP, TRANSACTIONAL_PRICING_PROP, SUB_PRICING_PROP, FREE_PRICING_PROP, DEALER_PRICING_PLAN];

const DAAB_API_DEETS = {
    "apiId": "300271a1-4dd7-4729-bd86-febb92bc6e21",
    "apiInfo": {
        "data": {
            isContracted: false,
            "id": "300271a1-4dd7-4729-bd86-febb92bc6e21",
            "orgId": "c95f3a83-0ddb-4a8a-941f-0a7485580cb1",
            "name": "2644 vs after the fact 2",
            "kind": "api",
            "orgName": "CDK Global - Jared R principal test org 5",
            "orgLogo": null,
            "description": "# DriveRightData North America and Mexico Vehicle Data, Search by Make Model\n## Abcdefgh\nLorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.\n* Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean nec lorem. In porttitor. Donec laoreet nonummy augue.\n* Suspendisse dui purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris eget neque at sem venenatis eleifend. Ut nonummy. Fusce aliquet pede non pede. Suspendisse dapibus lorem pellentesque magna. Integer nulla.\n## Alsdkjfldjsl\nDonec blandit feugiat ligula. Donec hendrerit, felis et imperdiet euismod, purus ipsum pretium metus, in lacinia nulla nisl eget sapien. Donec ut est in lectus consequat consequat. Etiam eget dui. Aliquam erat volutpat. Sed at lorem in nunc porta tristique.\nProin nec augue. Quisque aliquam tempor magna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nunc ac magna. Maecenas odio dolor, vulputate vel, auctor ac, accumsan id, felis. Pellentesque cursus sagittis felis.\nPellentesque porttitor, velit lacinia egestas auctor, diam eros tempus arcu, nec vulputate augue magna vel risus. Cras non magna vel ante adipiscing rhoncus. Vivamus a mi. Morbi neque. Aliquam erat volutpat. Integer ultrices lobortis eros.\n## Qoweuroweuor\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin semper, ante vitae sollicitudin posuere, metus quam iaculis nibh, vitae scelerisque nunc massa eget pede. Sed velit urna, interdum vel, ultricies vel, faucibus at, quam. Donec elit est, consectetuer eget, consequat quis, tempus quis, wisi. In in nunc.\n",
            "tags": [
                "bar",
                "foo"
            ],
            "environments": [
                {
                    "id": "639aa84d-2c0c-4dbb-bf99-b48e43174ba0",
                    "name": "prod",
                    "instances": [
                        {
                            "id": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                            "kind": "api-instance",
                            "apiId": "300271a1-4dd7-4729-bd86-febb92bc6e21",
                            "orgId": "c95f3a83-0ddb-4a8a-941f-0a7485580cb1",
                            "name": "2644 vs after the fact 2",
                            "version": "1.0.1",
                            "spec": {
                                "openapi": "3.0.0",
                                "info": {
                                    "version": "1.0.1",
                                    "title": "2644 vs after the fact 2",
                                    "description": "# DriveRightData North America and Mexico Vehicle Data, Search by Make Model\n## Abcdefgh\nLorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.\n* Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean nec lorem. In porttitor. Donec laoreet nonummy augue.\n* Suspendisse dui purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris eget neque at sem venenatis eleifend. Ut nonummy. Fusce aliquet pede non pede. Suspendisse dapibus lorem pellentesque magna. Integer nulla.\n## Alsdkjfldjsl\nDonec blandit feugiat ligula. Donec hendrerit, felis et imperdiet euismod, purus ipsum pretium metus, in lacinia nulla nisl eget sapien. Donec ut est in lectus consequat consequat. Etiam eget dui. Aliquam erat volutpat. Sed at lorem in nunc porta tristique.\nProin nec augue. Quisque aliquam tempor magna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nunc ac magna. Maecenas odio dolor, vulputate vel, auctor ac, accumsan id, felis. Pellentesque cursus sagittis felis.\nPellentesque porttitor, velit lacinia egestas auctor, diam eros tempus arcu, nec vulputate augue magna vel risus. Cras non magna vel ante adipiscing rhoncus. Vivamus a mi. Morbi neque. Aliquam erat volutpat. Integer ultrices lobortis eros.\n## Qoweuroweuor\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin semper, ante vitae sollicitudin posuere, metus quam iaculis nibh, vitae scelerisque nunc massa eget pede. Sed velit urna, interdum vel, ultricies vel, faucibus at, quam. Donec elit est, consectetuer eget, consequat quis, tempus quis, wisi. In in nunc.\n"
                                },
                                "servers": [
                                    {
                                        "url": "https://api.fortellis.io/service/rankinja/2644/VXPCkPfeOoM1/v1"
                                    }
                                ],
                                "tags": [
                                    {
                                        "name": "foo",
                                        "description": "Foo"
                                    },
                                    {
                                        "name": "bar",
                                        "description": "Bar"
                                    }
                                ],
                                "paths": {
                                    "/get-aaia-years": {
                                        "get": {
                                            "summary": "Get a list of AAIA years",
                                            "description": "Returns years dated back to 1959",
                                            "operationId": "GetAAIAYears",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaYearReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-regions": {
                                        "get": {
                                            "summary": "Get a list of AAIA regions",
                                            "description": "Returns regions for North America",
                                            "operationId": "GetAAIARegions",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaRegionReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-manufacturers": {
                                        "get": {
                                            "summary": "Get a list of AAIA manufacturers",
                                            "description": "Returns all manufacturers within specific region for test use Region ID=1, Year=2011",
                                            "operationId": "GetAAIAManufacturers",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaManufacturerReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-models": {
                                        "get": {
                                            "summary": "Get a list of AAIA models",
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year for test use Region ID=1, Year=2011, Manufacturer=Ford",
                                            "operationId": "GetAAIAModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-body-types": {
                                        "get": {
                                            "summary": "Get a list of AAIA body types",
                                            "description": "Returns body types of a selected model of the manufacturer within a specific year and a chosen region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150",
                                            "operationId": "GetAAIABodyTypes",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaBodyTypeReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-submodels": {
                                        "get": {
                                            "summary": "Get a list of AAIA submodels",
                                            "description": "Returns submodels for a selected body type, model and manufacturer, within a specific year and region.   For testing use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup",
                                            "operationId": "GetAAIASubModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaSubModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-vehicles": {
                                        "get": {
                                            "summary": "Get a list of AAIA vehicles",
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup, Sub Model=STX",
                                            "operationId": "GetAAIAVehicles",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.submodel"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaVehicleReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    }
                                },
                                "components": {
                                    "parameters": {
                                        "header.Request-Id": {
                                            "name": "Request-Id",
                                            "in": "header",
                                            "required": true,
                                            "description": "A correlation ID that should be returned back to the caller to indicate the return of the given request",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Subscription-Id": {
                                            "name": "Subscription-Id",
                                            "in": "header",
                                            "description": "The Fortellis Marketplace subscription identifier between a user entity and the solution. For sample responses use the Subscription-Id 'test' and your solution's apikey.",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Authorization": {
                                            "name": "Authorization",
                                            "in": "header",
                                            "description": "The bearer token",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.year": {
                                            "name": "year",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filter results by year",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.regionid": {
                                            "name": "regionid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by regionID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.manufacturer": {
                                            "name": "manufacturer",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by manufacturer",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.model": {
                                            "name": "model",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.bodytype": {
                                            "name": "bodytype",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by body type",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.submodel": {
                                            "name": "submodel",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by sub model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.chassisid": {
                                            "name": "chassisid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by chassisID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "responses": {
                                        "AaiaYearReturn": {
                                            "description": "This sends a response with all the AAIA years found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaYearReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "This sends a response with all the AAIA regions found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaRegionReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "This sends a response with all the AAIA manufacturers found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaManufacturerReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaModelReturn": {
                                            "description": "This sends a response with all the AAIA models found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "This sends a response with all the AAIA body types found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaBodyTypeReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "This sends a response with all the AAIA vehicles found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaVehicleReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "This sends a response with all the AAIA submodels found.",
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "This sends a response with all the AAIA submodel wheels found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelWheelsReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "BadRequest": {
                                            "description": "400 - Bad Request",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Unauthorized": {
                                            "description": "401 - Unauthorized",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Forbidden": {
                                            "description": "403 - Forbidden",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "NotFound": {
                                            "description": "404 - Not Found",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "InternalServerError": {
                                            "description": "500 - Internal Server Error",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "ServiceUnavailable": {
                                            "description": "503 - Service Unavailable",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "securitySchemes": {
                                        "permission-model": {
                                            "type": "oauth2",
                                            "flows": {
                                                "implicit": {
                                                    "authorizationUrl": "https://identity.fortellis.io/oauth2/",
                                                    "scopes": {
                                                        "anonymous": "Permissions to query and read parts"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "schemas": {
                                        "Health": {
                                            "description": "This is the code that tells you the server is okay.",
                                            "type": "object",
                                            "properties": {
                                                "message": {
                                                    "type": "string"
                                                },
                                                "code": {
                                                    "type": "number"
                                                },
                                                "links": {
                                                    "type": "object",
                                                    "properties": {
                                                        "self": {
                                                            "type": "object",
                                                            "properties": {
                                                                "href": {
                                                                    "type": "string"
                                                                },
                                                                "method": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "required": [
                                                "message",
                                                "code",
                                                "links"
                                            ],
                                            "example": {
                                                "message": "The server is up",
                                                "code": 200,
                                                "links": {
                                                    "self": {
                                                        "href": "/ping",
                                                        "method": "GET"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaYearReturn": {
                                            "description": "Returns years dated back to 1959",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011"
                                                },
                                                {
                                                    "year": "2012"
                                                }
                                            ]
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "Returns all manufacturers within specific region",
                                            "required": [
                                                "RegionID"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "regionID": {
                                                    "format": "int32",
                                                    "type": "integer"
                                                },
                                                "region": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "regionID": 1,
                                                    "region": "US"
                                                }
                                            ]
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a years",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "manufacturer": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "manufacturer": "Ford"
                                                }
                                            ]
                                        },
                                        "AaiaModelReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year",
                                            "required": [
                                                "Model"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "model": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "model": "Crown Victoria"
                                                },
                                                {
                                                    "model": "E-150"
                                                },
                                                {
                                                    "model": "E-250"
                                                },
                                                {
                                                    "model": "E-350 Super Duty"
                                                },
                                                {
                                                    "model": "Edge"
                                                },
                                                {
                                                    "model": "Escape"
                                                },
                                                {
                                                    "model": "Expedition"
                                                },
                                                {
                                                    "model": "Explorer"
                                                },
                                                {
                                                    "model": "F-150"
                                                }
                                            ]
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "Returns body types of a selected model of the manufacturer, within a specific year and a chosen region",
                                            "required": [
                                                "BodyType"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "bodyType": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "bodyType": "Crew Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Extended Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Standard Cab Pickup"
                                                }
                                            ]
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "Year",
                                                "Manufacturer",
                                                "Model",
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                },
                                                "manufacturer": {
                                                    "type": "string"
                                                },
                                                "model": {
                                                    "type": "string"
                                                },
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "driveType": {
                                                    "type": "string"
                                                },
                                                "bodyType": {
                                                    "type": "string"
                                                },
                                                "bodyNumberDoors": {
                                                    "type": "string"
                                                },
                                                "bedLength": {
                                                    "type": "string"
                                                },
                                                "vehicleType": {
                                                    "type": "string"
                                                },
                                                "region": {
                                                    "type": "string"
                                                },
                                                "customNote": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                },
                                                "treadType": {
                                                    "type": "string"
                                                },
                                                "issueNote": {
                                                    "type": "string"
                                                },
                                                "kw": {
                                                    "type": "string"
                                                },
                                                "cc": {
                                                    "type": "string"
                                                },
                                                "<script>alert(\"lol\");</script>": {
                                                    "type": "string"
                                                },
                                                "<style>div:after{content:\"lol\";}</style>": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "130",
                                                    "cc": "1497"
                                                },
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "118",
                                                    "cc": "1996"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "Returns submodels and relevant DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX"
                                                },
                                                {
                                                    "subModel": "XL"
                                                },
                                                {
                                                    "subModel": "XLT"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "Returns submodels and relevant DRDChassisID and DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16525"
                                                },
                                                {
                                                    "subModel": "STX 18\\\" option",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16522"
                                                },
                                                {
                                                    "subModel": "XL",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16521"
                                                },
                                                {
                                                    "subModel": "XL 18\\\" option",
                                                    "drChassisID": "16529",
                                                    "drModelID": "16531"
                                                }
                                            ]
                                        },
                                        "ErrorResponse": {
                                            "description": "Common error response object.",
                                            "properties": {
                                                "code": {
                                                    "type": "integer",
                                                    "format": "int32"
                                                },
                                                "message": {
                                                    "type": "string"
                                                }
                                            },
                                            "required": [
                                                "code",
                                                "message"
                                            ],
                                            "example": {
                                                "code": 400,
                                                "message": "Bad Request"
                                            }
                                        }
                                    }
                                }
                            },
                            "environment": "prod",
                            "config": {
                                "namespace": "jrpto5",
                                "proxyUrl": "https://api-dev.fortellis.io/jrpto5/service/rankinja/2644/VXPCkPfeOoM1/v1",
                                "advancedProxySettings": {
                                    "rateLimit": "10ps",
                                    "rateLimitPerApp": "234pm"
                                }
                            },
                            "lifecycleStatus": "General Release"
                        },
                        {
                            "id": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                            "kind": "api-instance",
                            "apiId": "300271a1-4dd7-4729-bd86-febb92bc6e21",
                            "orgId": "c95f3a83-0ddb-4a8a-941f-0a7485580cb1",
                            "name": "2644 vs after the fact 2",
                            "version": "1.0.2",
                            "spec": {
                                "openapi": "3.0.0",
                                "info": {
                                    "version": "1.0.2",
                                    "title": "2644 vs after the fact 2",
                                    "description": "# DriveRightData North America and Mexico Vehicle Data, Search by Make Model\n## Abcdefgh\nLorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.\n* Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean nec lorem. In porttitor. Donec laoreet nonummy augue.\n* Suspendisse dui purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris eget neque at sem venenatis eleifend. Ut nonummy. Fusce aliquet pede non pede. Suspendisse dapibus lorem pellentesque magna. Integer nulla.\n## Alsdkjfldjsl\nDonec blandit feugiat ligula. Donec hendrerit, felis et imperdiet euismod, purus ipsum pretium metus, in lacinia nulla nisl eget sapien. Donec ut est in lectus consequat consequat. Etiam eget dui. Aliquam erat volutpat. Sed at lorem in nunc porta tristique.\nProin nec augue. Quisque aliquam tempor magna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nunc ac magna. Maecenas odio dolor, vulputate vel, auctor ac, accumsan id, felis. Pellentesque cursus sagittis felis.\nPellentesque porttitor, velit lacinia egestas auctor, diam eros tempus arcu, nec vulputate augue magna vel risus. Cras non magna vel ante adipiscing rhoncus. Vivamus a mi. Morbi neque. Aliquam erat volutpat. Integer ultrices lobortis eros.\n## Qoweuroweuor\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin semper, ante vitae sollicitudin posuere, metus quam iaculis nibh, vitae scelerisque nunc massa eget pede. Sed velit urna, interdum vel, ultricies vel, faucibus at, quam. Donec elit est, consectetuer eget, consequat quis, tempus quis, wisi. In in nunc.\n"
                                },
                                "servers": [
                                    {
                                        "url": "https://api.fortellis.io/service/rankinja/2644/VXPCkPfeOoM1/v2"
                                    }
                                ],
                                "tags": [
                                    {
                                        "name": "foo",
                                        "description": "Foo"
                                    },
                                    {
                                        "name": "bar",
                                        "description": "Bar"
                                    }
                                ],
                                "paths": {
                                    "/get-aaia-years": {
                                        "get": {
                                            "summary": "Get a list of AAIA years",
                                            "description": "Returns years dated back to 1959",
                                            "operationId": "GetAAIAYears",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaYearReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-regions": {
                                        "get": {
                                            "summary": "Get a list of AAIA regions",
                                            "description": "Returns regions for North America",
                                            "operationId": "GetAAIARegions",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaRegionReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-manufacturers": {
                                        "get": {
                                            "summary": "Get a list of AAIA manufacturers",
                                            "description": "Returns all manufacturers within specific region for test use Region ID=1, Year=2011",
                                            "operationId": "GetAAIAManufacturers",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaManufacturerReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-models": {
                                        "get": {
                                            "summary": "Get a list of AAIA models",
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year for test use Region ID=1, Year=2011, Manufacturer=Ford",
                                            "operationId": "GetAAIAModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-body-types": {
                                        "get": {
                                            "summary": "Get a list of AAIA body types",
                                            "description": "Returns body types of a selected model of the manufacturer within a specific year and a chosen region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150",
                                            "operationId": "GetAAIABodyTypes",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaBodyTypeReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-submodels": {
                                        "get": {
                                            "summary": "Get a list of AAIA submodels",
                                            "description": "Returns submodels for a selected body type, model and manufacturer, within a specific year and region.   For testing use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup",
                                            "operationId": "GetAAIASubModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaSubModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-vehicles": {
                                        "get": {
                                            "summary": "Get a list of AAIA vehicles",
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup, Sub Model=STX",
                                            "operationId": "GetAAIAVehicles",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.submodel"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaVehicleReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    }
                                },
                                "components": {
                                    "parameters": {
                                        "header.Request-Id": {
                                            "name": "Request-Id",
                                            "in": "header",
                                            "required": true,
                                            "description": "A correlation ID that should be returned back to the caller to indicate the return of the given request",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Subscription-Id": {
                                            "name": "Subscription-Id",
                                            "in": "header",
                                            "description": "The Fortellis Marketplace subscription identifier between a user entity and the solution. For sample responses use the Subscription-Id 'test' and your solution's apikey.",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Authorization": {
                                            "name": "Authorization",
                                            "in": "header",
                                            "description": "The bearer token",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.year": {
                                            "name": "year",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filter results by year",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.regionid": {
                                            "name": "regionid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by regionID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.manufacturer": {
                                            "name": "manufacturer",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by manufacturer",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.model": {
                                            "name": "model",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.bodytype": {
                                            "name": "bodytype",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by body type",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.submodel": {
                                            "name": "submodel",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by sub model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.chassisid": {
                                            "name": "chassisid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by chassisID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "responses": {
                                        "AaiaYearReturn": {
                                            "description": "This sends a response with all the AAIA years found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaYearReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "This sends a response with all the AAIA regions found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaRegionReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "This sends a response with all the AAIA manufacturers found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaManufacturerReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaModelReturn": {
                                            "description": "This sends a response with all the AAIA models found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "This sends a response with all the AAIA body types found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaBodyTypeReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "This sends a response with all the AAIA vehicles found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaVehicleReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "This sends a response with all the AAIA submodels found.",
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "This sends a response with all the AAIA submodel wheels found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelWheelsReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "BadRequest": {
                                            "description": "400 - Bad Request",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Unauthorized": {
                                            "description": "401 - Unauthorized",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Forbidden": {
                                            "description": "403 - Forbidden",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "NotFound": {
                                            "description": "404 - Not Found",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "InternalServerError": {
                                            "description": "500 - Internal Server Error",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "ServiceUnavailable": {
                                            "description": "503 - Service Unavailable",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "securitySchemes": {
                                        "permission-model": {
                                            "type": "oauth2",
                                            "flows": {
                                                "implicit": {
                                                    "authorizationUrl": "https://identity.fortellis.io/oauth2/",
                                                    "scopes": {
                                                        "anonymous": "Permissions to query and read parts"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "schemas": {
                                        "Health": {
                                            "description": "This is the code that tells you the server is okay.",
                                            "type": "object",
                                            "properties": {
                                                "message": {
                                                    "type": "string"
                                                },
                                                "code": {
                                                    "type": "number"
                                                },
                                                "links": {
                                                    "type": "object",
                                                    "properties": {
                                                        "self": {
                                                            "type": "object",
                                                            "properties": {
                                                                "href": {
                                                                    "type": "string"
                                                                },
                                                                "method": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "required": [
                                                "message",
                                                "code",
                                                "links"
                                            ],
                                            "example": {
                                                "message": "The server is up",
                                                "code": 200,
                                                "links": {
                                                    "self": {
                                                        "href": "/ping",
                                                        "method": "GET"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaYearReturn": {
                                            "description": "Returns years dated back to 1959",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011"
                                                },
                                                {
                                                    "year": "2012"
                                                }
                                            ]
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "Returns all manufacturers within specific region",
                                            "required": [
                                                "RegionID"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "regionID": {
                                                    "format": "int32",
                                                    "type": "integer"
                                                },
                                                "region": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "regionID": 1,
                                                    "region": "US"
                                                }
                                            ]
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a years",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "manufacturer": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "manufacturer": "Ford"
                                                }
                                            ]
                                        },
                                        "AaiaModelReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year",
                                            "required": [
                                                "Model"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "model": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "model": "Crown Victoria"
                                                },
                                                {
                                                    "model": "E-150"
                                                },
                                                {
                                                    "model": "E-250"
                                                },
                                                {
                                                    "model": "E-350 Super Duty"
                                                },
                                                {
                                                    "model": "Edge"
                                                },
                                                {
                                                    "model": "Escape"
                                                },
                                                {
                                                    "model": "Expedition"
                                                },
                                                {
                                                    "model": "Explorer"
                                                },
                                                {
                                                    "model": "F-150"
                                                }
                                            ]
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "Returns body types of a selected model of the manufacturer, within a specific year and a chosen region",
                                            "required": [
                                                "BodyType"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "bodyType": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "bodyType": "Crew Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Extended Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Standard Cab Pickup"
                                                }
                                            ]
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "Year",
                                                "Manufacturer",
                                                "Model",
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                },
                                                "manufacturer": {
                                                    "type": "string"
                                                },
                                                "model": {
                                                    "type": "string"
                                                },
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "driveType": {
                                                    "type": "string"
                                                },
                                                "bodyType": {
                                                    "type": "string"
                                                },
                                                "bodyNumberDoors": {
                                                    "type": "string"
                                                },
                                                "bedLength": {
                                                    "type": "string"
                                                },
                                                "vehicleType": {
                                                    "type": "string"
                                                },
                                                "region": {
                                                    "type": "string"
                                                },
                                                "customNote": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                },
                                                "treadType": {
                                                    "type": "string"
                                                },
                                                "issueNote": {
                                                    "type": "string"
                                                },
                                                "kw": {
                                                    "type": "string"
                                                },
                                                "cc": {
                                                    "type": "string"
                                                },
                                                "<script>alert(\"lol\");</script>": {
                                                    "type": "string"
                                                },
                                                "<style>div:after{content:\"lol\";}</style>": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "130",
                                                    "cc": "1497"
                                                },
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "118",
                                                    "cc": "1996"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "Returns submodels and relevant DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX"
                                                },
                                                {
                                                    "subModel": "XL"
                                                },
                                                {
                                                    "subModel": "XLT"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "Returns submodels and relevant DRDChassisID and DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16525"
                                                },
                                                {
                                                    "subModel": "STX 18\\\" option",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16522"
                                                },
                                                {
                                                    "subModel": "XL",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16521"
                                                },
                                                {
                                                    "subModel": "XL 18\\\" option",
                                                    "drChassisID": "16529",
                                                    "drModelID": "16531"
                                                }
                                            ]
                                        },
                                        "ErrorResponse": {
                                            "description": "Common error response object.",
                                            "properties": {
                                                "code": {
                                                    "type": "integer",
                                                    "format": "int32"
                                                },
                                                "message": {
                                                    "type": "string"
                                                }
                                            },
                                            "required": [
                                                "code",
                                                "message"
                                            ],
                                            "example": {
                                                "code": 400,
                                                "message": "Bad Request"
                                            }
                                        }
                                    }
                                }
                            },
                            "environment": "prod",
                            "config": {
                                "namespace": "jrpto5",
                                "proxyUrl": "https://api-dev.fortellis.io/jrpto5/service/rankinja/2644/VXPCkPfeOoM1/v2",
                                "advancedProxySettings": {
                                    "rateLimit": "11ps",
                                    "rateLimitPerApp": "235pm"
                                }
                            },
                            "lifecycleStatus": "General Release"
                        }
                    ]
                },
                {
                    "id": "9a913dc3-3411-4958-a489-f8e41ba354e7",
                    "name": "test",
                    "instances": [
                        {
                            "id": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                            "kind": "api-instance",
                            "apiId": "300271a1-4dd7-4729-bd86-febb92bc6e21",
                            "orgId": "c95f3a83-0ddb-4a8a-941f-0a7485580cb1",
                            "name": "2644 vs after the fact 2",
                            "version": "1.0.3",
                            "spec": {
                                "openapi": "3.0.0",
                                "info": {
                                    "version": "1.0.3",
                                    "title": "2644 vs after the fact 2",
                                    "description": "# DriveRightData North America and Mexico Vehicle Data, Search by Make Model\n## Abcdefgh\nLorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.\n* Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean nec lorem. In porttitor. Donec laoreet nonummy augue.\n* Suspendisse dui purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris eget neque at sem venenatis eleifend. Ut nonummy. Fusce aliquet pede non pede. Suspendisse dapibus lorem pellentesque magna. Integer nulla.\n## Alsdkjfldjsl\nDonec blandit feugiat ligula. Donec hendrerit, felis et imperdiet euismod, purus ipsum pretium metus, in lacinia nulla nisl eget sapien. Donec ut est in lectus consequat consequat. Etiam eget dui. Aliquam erat volutpat. Sed at lorem in nunc porta tristique.\nProin nec augue. Quisque aliquam tempor magna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nunc ac magna. Maecenas odio dolor, vulputate vel, auctor ac, accumsan id, felis. Pellentesque cursus sagittis felis.\nPellentesque porttitor, velit lacinia egestas auctor, diam eros tempus arcu, nec vulputate augue magna vel risus. Cras non magna vel ante adipiscing rhoncus. Vivamus a mi. Morbi neque. Aliquam erat volutpat. Integer ultrices lobortis eros.\n## Qoweuroweuor\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin semper, ante vitae sollicitudin posuere, metus quam iaculis nibh, vitae scelerisque nunc massa eget pede. Sed velit urna, interdum vel, ultricies vel, faucibus at, quam. Donec elit est, consectetuer eget, consequat quis, tempus quis, wisi. In in nunc.\n"
                                },
                                "servers": [
                                    {
                                        "url": "https://api.fortellis.io/service/rankinja/2644/VXPCkPfeOoM1/v3"
                                    }
                                ],
                                "tags": [
                                    {
                                        "name": "foo",
                                        "description": "Foo"
                                    },
                                    {
                                        "name": "bar",
                                        "description": "Bar"
                                    }
                                ],
                                "paths": {
                                    "/get-aaia-years": {
                                        "get": {
                                            "summary": "Get a list of AAIA years",
                                            "description": "Returns years dated back to 1959",
                                            "operationId": "GetAAIAYears",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaYearReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-regions": {
                                        "get": {
                                            "summary": "Get a list of AAIA regions",
                                            "description": "Returns regions for North America",
                                            "operationId": "GetAAIARegions",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaRegionReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-manufacturers": {
                                        "get": {
                                            "summary": "Get a list of AAIA manufacturers",
                                            "description": "Returns all manufacturers within specific region for test use Region ID=1, Year=2011",
                                            "operationId": "GetAAIAManufacturers",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaManufacturerReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-models": {
                                        "get": {
                                            "summary": "Get a list of AAIA models",
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year for test use Region ID=1, Year=2011, Manufacturer=Ford",
                                            "operationId": "GetAAIAModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-body-types": {
                                        "get": {
                                            "summary": "Get a list of AAIA body types",
                                            "description": "Returns body types of a selected model of the manufacturer within a specific year and a chosen region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150",
                                            "operationId": "GetAAIABodyTypes",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaBodyTypeReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-submodels": {
                                        "get": {
                                            "summary": "Get a list of AAIA submodels",
                                            "description": "Returns submodels for a selected body type, model and manufacturer, within a specific year and region.   For testing use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup",
                                            "operationId": "GetAAIASubModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaSubModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-vehicles": {
                                        "get": {
                                            "summary": "Get a list of AAIA vehicles",
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup, Sub Model=STX",
                                            "operationId": "GetAAIAVehicles",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.submodel"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaVehicleReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    }
                                },
                                "components": {
                                    "parameters": {
                                        "header.Request-Id": {
                                            "name": "Request-Id",
                                            "in": "header",
                                            "required": true,
                                            "description": "A correlation ID that should be returned back to the caller to indicate the return of the given request",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Subscription-Id": {
                                            "name": "Subscription-Id",
                                            "in": "header",
                                            "description": "The Fortellis Marketplace subscription identifier between a user entity and the solution. For sample responses use the Subscription-Id 'test' and your solution's apikey.",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Authorization": {
                                            "name": "Authorization",
                                            "in": "header",
                                            "description": "The bearer token",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.year": {
                                            "name": "year",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filter results by year",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.regionid": {
                                            "name": "regionid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by regionID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.manufacturer": {
                                            "name": "manufacturer",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by manufacturer",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.model": {
                                            "name": "model",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.bodytype": {
                                            "name": "bodytype",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by body type",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.submodel": {
                                            "name": "submodel",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by sub model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.chassisid": {
                                            "name": "chassisid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by chassisID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "responses": {
                                        "AaiaYearReturn": {
                                            "description": "This sends a response with all the AAIA years found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaYearReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "This sends a response with all the AAIA regions found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaRegionReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "This sends a response with all the AAIA manufacturers found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaManufacturerReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaModelReturn": {
                                            "description": "This sends a response with all the AAIA models found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "This sends a response with all the AAIA body types found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaBodyTypeReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "This sends a response with all the AAIA vehicles found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaVehicleReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "This sends a response with all the AAIA submodels found.",
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "This sends a response with all the AAIA submodel wheels found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelWheelsReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "BadRequest": {
                                            "description": "400 - Bad Request",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Unauthorized": {
                                            "description": "401 - Unauthorized",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Forbidden": {
                                            "description": "403 - Forbidden",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "NotFound": {
                                            "description": "404 - Not Found",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "InternalServerError": {
                                            "description": "500 - Internal Server Error",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "ServiceUnavailable": {
                                            "description": "503 - Service Unavailable",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "securitySchemes": {
                                        "permission-model": {
                                            "type": "oauth2",
                                            "flows": {
                                                "implicit": {
                                                    "authorizationUrl": "https://identity.fortellis.io/oauth2/",
                                                    "scopes": {
                                                        "anonymous": "Permissions to query and read parts"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "schemas": {
                                        "Health": {
                                            "description": "This is the code that tells you the server is okay.",
                                            "type": "object",
                                            "properties": {
                                                "message": {
                                                    "type": "string"
                                                },
                                                "code": {
                                                    "type": "number"
                                                },
                                                "links": {
                                                    "type": "object",
                                                    "properties": {
                                                        "self": {
                                                            "type": "object",
                                                            "properties": {
                                                                "href": {
                                                                    "type": "string"
                                                                },
                                                                "method": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "required": [
                                                "message",
                                                "code",
                                                "links"
                                            ],
                                            "example": {
                                                "message": "The server is up",
                                                "code": 200,
                                                "links": {
                                                    "self": {
                                                        "href": "/ping",
                                                        "method": "GET"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaYearReturn": {
                                            "description": "Returns years dated back to 1959",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011"
                                                },
                                                {
                                                    "year": "2012"
                                                }
                                            ]
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "Returns all manufacturers within specific region",
                                            "required": [
                                                "RegionID"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "regionID": {
                                                    "format": "int32",
                                                    "type": "integer"
                                                },
                                                "region": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "regionID": 1,
                                                    "region": "US"
                                                }
                                            ]
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a years",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "manufacturer": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "manufacturer": "Ford"
                                                }
                                            ]
                                        },
                                        "AaiaModelReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year",
                                            "required": [
                                                "Model"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "model": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "model": "Crown Victoria"
                                                },
                                                {
                                                    "model": "E-150"
                                                },
                                                {
                                                    "model": "E-250"
                                                },
                                                {
                                                    "model": "E-350 Super Duty"
                                                },
                                                {
                                                    "model": "Edge"
                                                },
                                                {
                                                    "model": "Escape"
                                                },
                                                {
                                                    "model": "Expedition"
                                                },
                                                {
                                                    "model": "Explorer"
                                                },
                                                {
                                                    "model": "F-150"
                                                }
                                            ]
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "Returns body types of a selected model of the manufacturer, within a specific year and a chosen region",
                                            "required": [
                                                "BodyType"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "bodyType": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "bodyType": "Crew Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Extended Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Standard Cab Pickup"
                                                }
                                            ]
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "Year",
                                                "Manufacturer",
                                                "Model",
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                },
                                                "manufacturer": {
                                                    "type": "string"
                                                },
                                                "model": {
                                                    "type": "string"
                                                },
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "driveType": {
                                                    "type": "string"
                                                },
                                                "bodyType": {
                                                    "type": "string"
                                                },
                                                "bodyNumberDoors": {
                                                    "type": "string"
                                                },
                                                "bedLength": {
                                                    "type": "string"
                                                },
                                                "vehicleType": {
                                                    "type": "string"
                                                },
                                                "region": {
                                                    "type": "string"
                                                },
                                                "customNote": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                },
                                                "treadType": {
                                                    "type": "string"
                                                },
                                                "issueNote": {
                                                    "type": "string"
                                                },
                                                "kw": {
                                                    "type": "string"
                                                },
                                                "cc": {
                                                    "type": "string"
                                                },
                                                "<script>alert(\"lol\");</script>": {
                                                    "type": "string"
                                                },
                                                "<style>div:after{content:\"lol\";}</style>": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "130",
                                                    "cc": "1497"
                                                },
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "118",
                                                    "cc": "1996"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "Returns submodels and relevant DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX"
                                                },
                                                {
                                                    "subModel": "XL"
                                                },
                                                {
                                                    "subModel": "XLT"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "Returns submodels and relevant DRDChassisID and DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16525"
                                                },
                                                {
                                                    "subModel": "STX 18\\\" option",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16522"
                                                },
                                                {
                                                    "subModel": "XL",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16521"
                                                },
                                                {
                                                    "subModel": "XL 18\\\" option",
                                                    "drChassisID": "16529",
                                                    "drModelID": "16531"
                                                }
                                            ]
                                        },
                                        "ErrorResponse": {
                                            "description": "Common error response object.",
                                            "properties": {
                                                "code": {
                                                    "type": "integer",
                                                    "format": "int32"
                                                },
                                                "message": {
                                                    "type": "string"
                                                }
                                            },
                                            "required": [
                                                "code",
                                                "message"
                                            ],
                                            "example": {
                                                "code": 400,
                                                "message": "Bad Request"
                                            }
                                        }
                                    }
                                }
                            },
                            "environment": "prod",
                            "config": {
                                "namespace": "jrpto5",
                                "proxyUrl": "https://api-dev.fortellis.io/jrpto5/service/rankinja/2644/VXPCkPfeOoM1/v3",
                                "advancedProxySettings": {
                                    "rateLimit": "12ps",
                                    "rateLimitPerApp": "236pm"
                                }
                            },
                            "lifecycleStatus": "Beta"
                        },
                        {
                            "id": "0083161c-0b75-4333-9a78-e29fd3705fc3",
                            "kind": "api-instance",
                            "apiId": "300271a1-4dd7-4729-bd86-febb92bc6e21",
                            "orgId": "c95f3a83-0ddb-4a8a-941f-0a7485580cb1",
                            "name": "2644 vs after the fact 2",
                            "version": "1.0.4",
                            "spec": {
                                "openapi": "3.0.0",
                                "info": {
                                    "version": "1.0.2",
                                    "title": "2644 vs after the fact 2",
                                    "description": "# DriveRightData North America and Mexico Vehicle Data, Search by Make Model\n## Abcdefgh\nLorem ipsum dolor sit amet, consectetuer adipiscing elit. Maecenas porttitor congue massa. Fusce posuere, magna sed pulvinar ultricies, purus lectus malesuada libero, sit amet commodo magna eros quis urna. Nunc viverra imperdiet enim. Fusce est. Vivamus a tellus.\n* Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin pharetra nonummy pede. Mauris et orci. Aenean nec lorem. In porttitor. Donec laoreet nonummy augue.\n* Suspendisse dui purus, scelerisque at, vulputate vitae, pretium mattis, nunc. Mauris eget neque at sem venenatis eleifend. Ut nonummy. Fusce aliquet pede non pede. Suspendisse dapibus lorem pellentesque magna. Integer nulla.\n## Alsdkjfldjsl\nDonec blandit feugiat ligula. Donec hendrerit, felis et imperdiet euismod, purus ipsum pretium metus, in lacinia nulla nisl eget sapien. Donec ut est in lectus consequat consequat. Etiam eget dui. Aliquam erat volutpat. Sed at lorem in nunc porta tristique.\nProin nec augue. Quisque aliquam tempor magna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nunc ac magna. Maecenas odio dolor, vulputate vel, auctor ac, accumsan id, felis. Pellentesque cursus sagittis felis.\nPellentesque porttitor, velit lacinia egestas auctor, diam eros tempus arcu, nec vulputate augue magna vel risus. Cras non magna vel ante adipiscing rhoncus. Vivamus a mi. Morbi neque. Aliquam erat volutpat. Integer ultrices lobortis eros.\n## Qoweuroweuor\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin semper, ante vitae sollicitudin posuere, metus quam iaculis nibh, vitae scelerisque nunc massa eget pede. Sed velit urna, interdum vel, ultricies vel, faucibus at, quam. Donec elit est, consectetuer eget, consequat quis, tempus quis, wisi. In in nunc.\n"
                                },
                                "servers": [
                                    {
                                        "url": "https://api.fortellis.io/service/rankinja/2644/VXPCkPfeOoM1/v4"
                                    }
                                ],
                                "tags": [
                                    {
                                        "name": "foo",
                                        "description": "Foo"
                                    },
                                    {
                                        "name": "bar",
                                        "description": "Bar"
                                    }
                                ],
                                "paths": {
                                    "/get-aaia-years": {
                                        "get": {
                                            "summary": "Get a list of AAIA years",
                                            "description": "Returns years dated back to 1959",
                                            "operationId": "GetAAIAYears",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaYearReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-regions": {
                                        "get": {
                                            "summary": "Get a list of AAIA regions",
                                            "description": "Returns regions for North America",
                                            "operationId": "GetAAIARegions",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaRegionReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-manufacturers": {
                                        "get": {
                                            "summary": "Get a list of AAIA manufacturers",
                                            "description": "Returns all manufacturers within specific region for test use Region ID=1, Year=2011",
                                            "operationId": "GetAAIAManufacturers",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaManufacturerReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-models": {
                                        "get": {
                                            "summary": "Get a list of AAIA models",
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year for test use Region ID=1, Year=2011, Manufacturer=Ford",
                                            "operationId": "GetAAIAModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-body-types": {
                                        "get": {
                                            "summary": "Get a list of AAIA body types",
                                            "description": "Returns body types of a selected model of the manufacturer within a specific year and a chosen region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150",
                                            "operationId": "GetAAIABodyTypes",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaBodyTypeReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-submodels": {
                                        "get": {
                                            "summary": "Get a list of AAIA submodels",
                                            "description": "Returns submodels for a selected body type, model and manufacturer, within a specific year and region.   For testing use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup",
                                            "operationId": "GetAAIASubModels",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaSubModelReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    },
                                    "/get-aaia-vehicles": {
                                        "get": {
                                            "summary": "Get a list of AAIA vehicles",
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region for test use Region ID=1, Year=2011, Manufacturer=Ford, Model=F-150, Bodytype=Standard Cab Pickup, Sub Model=STX",
                                            "operationId": "GetAAIAVehicles",
                                            "parameters": [
                                                {
                                                    "$ref": "#/components/parameters/header.Request-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Subscription-Id"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/header.Authorization"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.year"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.regionid"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.manufacturer"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.model"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.bodytype"
                                                },
                                                {
                                                    "$ref": "#/components/parameters/query.submodel"
                                                }
                                            ],
                                            "responses": {
                                                "200": {
                                                    "$ref": "#/components/responses/AaiaVehicleReturn"
                                                },
                                                "400": {
                                                    "$ref": "#/components/responses/BadRequest"
                                                },
                                                "401": {
                                                    "$ref": "#/components/responses/Unauthorized"
                                                },
                                                "403": {
                                                    "$ref": "#/components/responses/Forbidden"
                                                },
                                                "503": {
                                                    "$ref": "#/components/responses/ServiceUnavailable"
                                                }
                                            },
                                            "tags": [
                                                "Vehicle Search"
                                            ],
                                            "externalDocs": {
                                                "description": "Find more info here.",
                                                "url": "https://swagger.io"
                                            }
                                        }
                                    }
                                },
                                "components": {
                                    "parameters": {
                                        "header.Request-Id": {
                                            "name": "Request-Id",
                                            "in": "header",
                                            "required": true,
                                            "description": "A correlation ID that should be returned back to the caller to indicate the return of the given request",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Subscription-Id": {
                                            "name": "Subscription-Id",
                                            "in": "header",
                                            "description": "The Fortellis Marketplace subscription identifier between a user entity and the solution. For sample responses use the Subscription-Id 'test' and your solution's apikey.",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "header.Authorization": {
                                            "name": "Authorization",
                                            "in": "header",
                                            "description": "The bearer token",
                                            "required": true,
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.year": {
                                            "name": "year",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filter results by year",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.regionid": {
                                            "name": "regionid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by regionID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.manufacturer": {
                                            "name": "manufacturer",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by manufacturer",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.model": {
                                            "name": "model",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.bodytype": {
                                            "name": "bodytype",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by body type",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.submodel": {
                                            "name": "submodel",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by sub model",
                                            "schema": {
                                                "type": "string"
                                            }
                                        },
                                        "query.chassisid": {
                                            "name": "chassisid",
                                            "in": "query",
                                            "required": true,
                                            "description": "Filters results by chassisID",
                                            "schema": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "responses": {
                                        "AaiaYearReturn": {
                                            "description": "This sends a response with all the AAIA years found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaYearReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "This sends a response with all the AAIA regions found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaRegionReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "This sends a response with all the AAIA manufacturers found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaManufacturerReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaModelReturn": {
                                            "description": "This sends a response with all the AAIA models found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "This sends a response with all the AAIA body types found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaBodyTypeReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "This sends a response with all the AAIA vehicles found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaVehicleReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "This sends a response with all the AAIA submodels found.",
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "This sends a response with all the AAIA submodel wheels found.",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/AaiaSubModelWheelsReturn"
                                                    }
                                                }
                                            }
                                        },
                                        "BadRequest": {
                                            "description": "400 - Bad Request",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Unauthorized": {
                                            "description": "401 - Unauthorized",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "Forbidden": {
                                            "description": "403 - Forbidden",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "NotFound": {
                                            "description": "404 - Not Found",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "InternalServerError": {
                                            "description": "500 - Internal Server Error",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        },
                                        "ServiceUnavailable": {
                                            "description": "503 - Service Unavailable",
                                            "headers": {
                                                "Request-Id": {
                                                    "schema": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "content": {
                                                "application/json": {
                                                    "schema": {
                                                        "$ref": "#/components/schemas/ErrorResponse"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "securitySchemes": {
                                        "permission-model": {
                                            "type": "oauth2",
                                            "flows": {
                                                "implicit": {
                                                    "authorizationUrl": "https://identity.fortellis.io/oauth2/",
                                                    "scopes": {
                                                        "anonymous": "Permissions to query and read parts"
                                                    }
                                                }
                                            }
                                        }
                                    },
                                    "schemas": {
                                        "Health": {
                                            "description": "This is the code that tells you the server is okay.",
                                            "type": "object",
                                            "properties": {
                                                "message": {
                                                    "type": "string"
                                                },
                                                "code": {
                                                    "type": "number"
                                                },
                                                "links": {
                                                    "type": "object",
                                                    "properties": {
                                                        "self": {
                                                            "type": "object",
                                                            "properties": {
                                                                "href": {
                                                                    "type": "string"
                                                                },
                                                                "method": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            },
                                            "required": [
                                                "message",
                                                "code",
                                                "links"
                                            ],
                                            "example": {
                                                "message": "The server is up",
                                                "code": 200,
                                                "links": {
                                                    "self": {
                                                        "href": "/ping",
                                                        "method": "GET"
                                                    }
                                                }
                                            }
                                        },
                                        "AaiaYearReturn": {
                                            "description": "Returns years dated back to 1959",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011"
                                                },
                                                {
                                                    "year": "2012"
                                                }
                                            ]
                                        },
                                        "AaiaRegionReturn": {
                                            "description": "Returns all manufacturers within specific region",
                                            "required": [
                                                "RegionID"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "regionID": {
                                                    "format": "int32",
                                                    "type": "integer"
                                                },
                                                "region": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "regionID": 1,
                                                    "region": "US"
                                                }
                                            ]
                                        },
                                        "AaiaManufacturerReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a years",
                                            "required": [
                                                "year"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "manufacturer": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "manufacturer": "Ford"
                                                }
                                            ]
                                        },
                                        "AaiaModelReturn": {
                                            "description": "Returns all models within specific region, for a selected manufacturer and a year",
                                            "required": [
                                                "Model"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "model": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "model": "Crown Victoria"
                                                },
                                                {
                                                    "model": "E-150"
                                                },
                                                {
                                                    "model": "E-250"
                                                },
                                                {
                                                    "model": "E-350 Super Duty"
                                                },
                                                {
                                                    "model": "Edge"
                                                },
                                                {
                                                    "model": "Escape"
                                                },
                                                {
                                                    "model": "Expedition"
                                                },
                                                {
                                                    "model": "Explorer"
                                                },
                                                {
                                                    "model": "F-150"
                                                }
                                            ]
                                        },
                                        "AaiaBodyTypeReturn": {
                                            "description": "Returns body types of a selected model of the manufacturer, within a specific year and a chosen region",
                                            "required": [
                                                "BodyType"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "bodyType": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "bodyType": "Crew Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Extended Cab Pickup"
                                                },
                                                {
                                                    "bodyType": "Standard Cab Pickup"
                                                }
                                            ]
                                        },
                                        "AaiaVehicleReturn": {
                                            "description": "Returns vehicle data for the selected submodel, body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "Year",
                                                "Manufacturer",
                                                "Model",
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "year": {
                                                    "type": "string"
                                                },
                                                "manufacturer": {
                                                    "type": "string"
                                                },
                                                "model": {
                                                    "type": "string"
                                                },
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "driveType": {
                                                    "type": "string"
                                                },
                                                "bodyType": {
                                                    "type": "string"
                                                },
                                                "bodyNumberDoors": {
                                                    "type": "string"
                                                },
                                                "bedLength": {
                                                    "type": "string"
                                                },
                                                "vehicleType": {
                                                    "type": "string"
                                                },
                                                "region": {
                                                    "type": "string"
                                                },
                                                "customNote": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                },
                                                "treadType": {
                                                    "type": "string"
                                                },
                                                "issueNote": {
                                                    "type": "string"
                                                },
                                                "kw": {
                                                    "type": "string"
                                                },
                                                "cc": {
                                                    "type": "string"
                                                },
                                                "<script>alert(\"lol\");</script>": {
                                                    "type": "string"
                                                },
                                                "<style>div:after{content:\"lol\";}</style>": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "130",
                                                    "cc": "1497"
                                                },
                                                {
                                                    "year": "2011",
                                                    "manufacturer": "Ford",
                                                    "model": "F-150",
                                                    "subModel": "STX",
                                                    "driveType": "4WD",
                                                    "bodyType": "Sedan",
                                                    "bodyNumberDoors": "4",
                                                    "bedLength": "N/R",
                                                    "vehicleType": "Car",
                                                    "region": "United States",
                                                    "drChassisID": "67521",
                                                    "drModelID": "67522",
                                                    "kw": "118",
                                                    "cc": "1996"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelReturn": {
                                            "description": "Returns submodels and relevant DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX"
                                                },
                                                {
                                                    "subModel": "XL"
                                                },
                                                {
                                                    "subModel": "XLT"
                                                }
                                            ]
                                        },
                                        "AaiaSubModelWheelsReturn": {
                                            "description": "Returns submodels and relevant DRDChassisID and DRDModelIDs of a selected body type, model of the manufacturer, within a specific year and the region",
                                            "required": [
                                                "SubModel"
                                            ],
                                            "type": "object",
                                            "properties": {
                                                "subModel": {
                                                    "type": "string"
                                                },
                                                "drChassisID": {
                                                    "type": "string"
                                                },
                                                "drModelID": {
                                                    "type": "string"
                                                }
                                            },
                                            "example": [
                                                {
                                                    "subModel": "STX",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16525"
                                                },
                                                {
                                                    "subModel": "STX 18\\\" option",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16522"
                                                },
                                                {
                                                    "subModel": "XL",
                                                    "drChassisID": "16520",
                                                    "drModelID": "16521"
                                                },
                                                {
                                                    "subModel": "XL 18\\\" option",
                                                    "drChassisID": "16529",
                                                    "drModelID": "16531"
                                                }
                                            ]
                                        },
                                        "ErrorResponse": {
                                            "description": "Common error response object.",
                                            "properties": {
                                                "code": {
                                                    "type": "integer",
                                                    "format": "int32"
                                                },
                                                "message": {
                                                    "type": "string"
                                                }
                                            },
                                            "required": [
                                                "code",
                                                "message"
                                            ],
                                            "example": {
                                                "code": 400,
                                                "message": "Bad Request"
                                            }
                                        }
                                    }
                                }
                            },
                            "environment": "test",
                            "config": {
                                "namespace": "jrpto5",
                                "proxyUrl": "https://api-dev.fortellis.io/jrpto5/service/rankinja/2644/VXPCkPfeOoM1/v4",
                                "advancedProxySettings": {
                                    "rateLimit": "9ps",
                                    "rateLimitPerApp": "233pm"
                                }
                            },
                            "lifecycleStatus": "Beta"
                        }
                    ]
                }
            ],
            "defaultNamespace": "",
            "contact": {
                "general": {
                    "email": "jared.rankin@cdk.com",
                    "phone": "8888888888",
                    "phoneExt": "567",
                    "url": "https://google.com",
                    "name": "jared.rankin@cdk.com"
                },
                "sales": {
                    "email": "abc@abc.com",
                    "phone": "12312312",
                    "phoneExt": "090",
                    "url": "https://cdk.com",
                    "name": "Abc Cdf"
                },
                "support": {
                    "email": "Jane.Doe@xyz.com",
                    "phone": "767676767",
                    "phoneExt": "343",
                    "url": "https://xyz.org",
                    "name": "Jane Doe"
                }
            },
            "externalDocs": [
                {
                    "id": "3d807473-e67c-4794-834a-20fa7bf928ef",
                    "name": "sdjflskdjldks",
                    "fileName": null,
                    "urlLink": "https://fortellis.io",
                    "url": "https://example.com/sample.pdf",
                    "lastUpdated": "2024-03-12T20:02:38.436Z"
                },
                {
                    "id": "3d807473-e6hhhhhh7bf928ef",
                    "name": "Tutorial Document test",
                    "fileName": 'Test Doc',
                    "urlLink": "https://fortellis.io",
                    "url": "https://example.com/sample.pdf",
                    "lastUpdated": "2024-05-12T20:02:38.436Z"
                }
            ],
            "plans": API_PLANS,
            "terms": [
                {
                    "id": "164835cd-bff8-4755-958e-d4dbd9af9594",
                    "type": "terms",
                    "fileName": "test-terms.pdf",
                    "status": "active",
                    "url": "https://fortellis-api-documents-dev.s3-us-west-2.amazonaws.com/300271a1-4dd7-4729-bd86-febb92bc6e21/terms/20240312200340517-_akBO8CH.pdf",
                    "lastUpdated": "2024-03-12T20:03:40.738Z"
                }
            ],
            "visibility": "public",
            "apiType": "api",
            "catalogNumber": null,
            "summary": "sdfghjkl",
            "dataRefreshRate": "15m"
        },
        "isFetching": false,
        "oneToOneApiAnon": false,
        "error": null
    },
    "auth": {
        "isAuthenticated": true,
        "userData": {
            "sub": "00ueoz79hiepLD1j92p7",
            "name": "Ayesha Shaikh",
            "email": "ayesha.shaikh@cdk.com",
            "ver": 1,
            "iss": "https://sso-test.fortellis.io/oauth2/aus1ni5i9n9WkzcYa2p7",
            "aud": "0oa4qokpibPph9mnb2p7",
            "iat": 1714924227,
            "exp": 1714927827,
            "jti": "ID.G31QiGpZ2u9O60W9dD1k71UhZFUyCfzF3XUCwfwJRxk",
            "amr": [
                "pwd"
            ],
            "idp": "00o1an48q1Su1RCFh2p7",
            "nonce": "Y9bFLvT4iJfU3MHuusE1FwbBjoklqavHkP1MG2gpBaVLtluogU5B4dzJZ4vYRhJ8",
            "preferred_username": "ayesha.shaikh@cdk.com",
            "auth_time": 1714921376,
            "at_hash": "8DXqc-tGYTmZrr3rs_pRjA"
        },
        "accessToken": "eyJraWQiOiJsMHlQWkVEbk9QYXkzcmZOYWRYak43UkYyXzZmZnQyWEVxY1pDc2c5cWxzIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULnY3aTFzdmNvUTZrNEV4S1l5Q29zRUVVcXFBZWtfWko2UFF3SGtyaV9qdFkiLCJpc3MiOiJodHRwczovL3Nzby10ZXN0LmZvcnRlbGxpcy5pby9vYXV0aDIvYXVzMW5pNWk5bjlXa3pjWWEycDciLCJhdWQiOiJhcGlfcHJvdmlkZXJzIiwic3ViIjoiYXllc2hhLnNoYWlraEBjZGsuY29tIiwiaWF0IjoxNzE0OTI0MjI3LCJleHAiOjE3MTQ5Mjc4MjcsImNpZCI6IjBvYTRxb2twaWJQcGg5bW5iMnA3IiwidWlkIjoiMDB1ZW96NzloaWVwTEQxajkycDciLCJzY3AiOlsiZW1haWwiLCJwcm9maWxlIiwib3BlbmlkIl0sImF1dGhfdGltZSI6MTcxNDkyMTM3NiwiZW50aXRsZW1lbnRzIjp7IjFmMTY3OTFkLTQyYjgtNDMyMi04YTIxLWE0OGFhNTFjZDU4OCI6eyJyb2xlcy1tYW5hZ2VtZW50IjpbImFzc2lnblJvbGUiLCJ1bmFzc2lnblJvbGUiXSwiaW52aXRhdGlvbi1tYW5hZ2VtZW50IjpbImludml0ZVVzZXIiLCJ1cGRhdGVJbnZpdGF0aW9uU3RhdHVzIl0sImVudGl0eS1tZ210IjpbInJlbW92ZVVzZXJGcm9tRW50aXR5IiwiYWRkVXNlclRvRW50aXR5IiwibWFuYWdlRW50aXR5UHJvZmlsZSIsImdldEFsbEVudGl0aWVzIiwidXBkYXRlRW50aXR5IiwiZ2V0RW50aXR5SGllcmFyY2h5IiwiZ2V0RW50aXR5VXNlcnMiLCJpbnZpdGVVc2VyIiwiYXBwcm92ZVVzZXIiXSwicGVybXMtbWdtdCI6WyJhZGRVc2VyVG9FbnRpdHkiLCJyZW1vdmVVc2VyRnJvbUVudGl0eSIsImFzc2lnblN0YXRlbWVudFRvVXNlciIsInVuYXNzaWduU3RhdGVtZW50RnJvbVVzZXIiXSwiZW50aXRsZW1lbnRzLW1nbXQiOlsidXBkYXRlRW50aXRsZW1lbnRzIl19fSwiZW50aXR5SWQiOiIxZjE2NzkxZC00MmI4LTQzMjItOGEyMS1hNDhhYTUxY2Q1ODgifQ.ea9pt1fC2r4Y-p4im3KabCZ15JM3cdIjVmO6E3ZW0_LMpIL-nSflRjerRiy5KCfV02IblV1vOoDgIy93R4rvLrCbzuLaTp5P_mtsCqVSxwe0BpB7fS5eT9qvr_yH0Eab1RA--hHN5i2SA230Ffl6apRJ4e900Oo-klMD9hto9B3ix9vduWZLTIuPfmThC1DG3o6y8eqds9LfEWN3B0Wp9lGVhr_lmpU6XaK-0P1qDH06u0My8G-bM-tEczXbiE__f11_RlvpDVErJ4GuZlX_e0-jyWSey3Xz7q-8vUFj32_oYp3H3PLM8hHjV8It2vsiimiQ1_WvepIzRem8ndvMqg",
        "idToken": "eyJraWQiOiJsMHlQWkVEbk9QYXkzcmZOYWRYak43UkYyXzZmZnQyWEVxY1pDc2c5cWxzIiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIwMHVlb3o3OWhpZXBMRDFqOTJwNyIsIm5hbWUiOiJBeWVzaGEgU2hhaWtoIiwiZW1haWwiOiJheWVzaGEuc2hhaWtoQGNkay5jb20iLCJ2ZXIiOjEsImlzcyI6Imh0dHBzOi8vc3NvLXRlc3QuZm9ydGVsbGlzLmlvL29hdXRoMi9hdXMxbmk1aTluOVdremNZYTJwNyIsImF1ZCI6IjBvYTRxb2twaWJQcGg5bW5iMnA3IiwiaWF0IjoxNzE0OTI0MjI3LCJleHAiOjE3MTQ5Mjc4MjcsImp0aSI6IklELkczMVFpR3BaMnU5TzYwVzlkRDFrNzFVaFpGVXlDZnpGM1hVQ3dmd0pSeGsiLCJhbXIiOlsicHdkIl0sImlkcCI6IjAwbzFhbjQ4cTFTdTFSQ0ZoMnA3Iiwibm9uY2UiOiJZOWJGTHZUNGlKZlUzTUh1dXNFMUZ3YkJqb2tscWF2SGtQMU1HMmdwQmFWTHRsdW9nVTVCNGR6Slo0dllSaEo4IiwicHJlZmVycmVkX3VzZXJuYW1lIjoiYXllc2hhLnNoYWlraEBjZGsuY29tIiwiYXV0aF90aW1lIjoxNzE0OTIxMzc2LCJhdF9oYXNoIjoiOERYcWMtdEdZVG1acnIzcnNfcFJqQSJ9.sTZCiMO_xOpduQDmsZsgm8_HnEl77ZX4CCIhjmB3csRv5vSVrtco8pUAWysKKt8zyzmbOnwggbUXqYK3675dcgtVhNnh2h0OQos-Yj_F3ao4R8eqhpYDF-jwfMzxU2O6dXOMmASj0oWqSQbimq0PveRRTrUX7o55npfa1CJhvylHZ0jhS8ieAXsZYNWJKUB9X7FlJq22Lh39Vy_n4-hSD7x_8i0raRAfqPW6fbmg0P03LZphPKo46R_xVGRBK8CWueYHnXR2E3r54skx8mz-kOOVvEzGDFUXVjkcJU8xip-2dTcE91spbgNgaPnxN79oEHNgySbx-SkfDrFdY-REUw",
        "loginPending": false,
        "entityId": "1f16791d-42b8-4322-8a21-a48aa51cd588",
        "entitlements": {
            "1f16791d-42b8-4322-8a21-a48aa51cd588": {
                "roles-management": [
                    "assignRole",
                    "unassignRole"
                ],
                "invitation-management": [
                    "inviteUser",
                    "updateInvitationStatus"
                ],
                "entity-mgmt": [
                    "removeUserFromEntity",
                    "addUserToEntity",
                    "manageEntityProfile",
                    "getAllEntities",
                    "updateEntity",
                    "getEntityHierarchy",
                    "getEntityUsers",
                    "inviteUser",
                    "approveUser"
                ],
                "perms-mgmt": [
                    "addUserToEntity",
                    "removeUserFromEntity",
                    "assignStatementToUser",
                    "unassignStatementFromUser"
                ],
                "entitlements-mgmt": [
                    "updateEntitlements"
                ]
            }
        },
        "expiresAt": "2024-05-05T16:50:27.000Z"
    }
}

const CART_DETAILS = []

const ORDER_DETAILS = []

const CART_ITEMS = [];


export { cartDetails, PRICING_PROP, SUB_PRICING_PROP, FREE_PRICING_PROP, TRANSACTIONAL_PRICING_PROP, PRICING_PLAN_STATE, DAAB_API_DEETS }
